const { default: APP_CONFIG } = require('constants/appConfig');

const primaryColor = APP_CONFIG.color.primary;
const secondaryColor = APP_CONFIG.color.secondary;
const btnHoverColor = APP_CONFIG.color.btnHover;
const linkHoverColor = APP_CONFIG.color.linkHover;
const topbarColor = APP_CONFIG.color.topbar;
const sidebarColor = APP_CONFIG.color.sidebar;

document.documentElement.style.setProperty('--secondary-color', secondaryColor);
document.documentElement.style.setProperty('--primary-color', primaryColor);
document.documentElement.style.setProperty('--hover-color', btnHoverColor);
document.documentElement.style.setProperty('--link-color', linkHoverColor);
document.documentElement.style.setProperty('--topbar-color', topbarColor);
document.documentElement.style.setProperty('--sidebar-color', sidebarColor);
